import { ManageThreadsApi, ThreadsApi, useAPIAction } from "melco-shared-logic";

export const useDownloadThread = (
    id: string | undefined
) => {
    return useAPIAction(
        ManageThreadsApi,
        async (api) => {
            const data = await api.threadsDownloadThread({
                id: id ?? ""
            });
            //  console.log(data)
            return {
                successMessages: [],
                data,
            };
        },
        { translationPrefix: "global" }
    );
};
